import { memo, useCallback } from "react";

import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import { Accordion } from "./accordion";
import { FormIslandSection } from "./island-section";

type Props = {
	gtmId?: string;
	errorMessage?: string;
	onChangeGtmID: (value: string) => void;
};

export const AnalysisSettingForm = memo(({ gtmId, errorMessage, onChangeGtmID }: Props) => {
	const handleChangeGtmID = useCallback(
		(value: string) => {
			onChangeGtmID(value);
		},
		[onChangeGtmID],
	);

	return (
		<FormIslandSection title="分析設定">
			<Accordion labelChildren={<label className="text-[#4c4c4c]">GTMの設定</label>}>
				<div className="space-y-2 p-1">
					<InputTextField value={gtmId} errorMessage={errorMessage} handleChange={handleChangeGtmID} />
					<p className="text whitespace-pre-wrap text-xs text-caption-50">
						{`GTM(Google Tag Manager)を利用して、サイトのアクセス解析を行うことができます。\nGTMから始まる（「GTM-XXXXXXX」）コンテナIDを取得してください。この設定はいつでも変更できます。`}
					</p>
				</div>
			</Accordion>
		</FormIslandSection>
	);
});
